function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M2 9.75c-.41 0-.75-.34-.75-.75V6.5c0-2.9 2.36-5.25 5.25-5.25H9c.41 0 .75.34.75.75s-.34.75-.75.75H6.5c-2.07 0-3.75 1.68-3.75 3.75V9c0 .41-.34.75-.75.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 9.75c-.41 0-.75-.34-.75-.75V6.5c0-2.07-1.68-3.75-3.75-3.75H15c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.5c2.89 0 5.25 2.35 5.25 5.25V9c0 .41-.34.75-.75.75z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M17.5 22.75H16c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.5c2.07 0 3.75-1.68 3.75-3.75V16c0-.41.34-.75.75-.75s.75.34.75.75v1.5c0 2.9-2.36 5.25-5.25 5.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 22.75H6.5c-2.89 0-5.25-2.35-5.25-5.25V15c0-.41.34-.75.75-.75s.75.34.75.75v2.5c0 2.07 1.68 3.75 3.75 3.75H9c.41 0 .75.34.75.75s-.34.75-.75.75zm-.5-11.37a2.88 2.88 0 100-5.76 2.88 2.88 0 000 5.76z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M7.5 18.38a1.88 1.88 0 100-3.76 1.88 1.88 0 000 3.76zm9-9a1.88 1.88 0 100-3.76 1.88 1.88 0 000 3.76z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 18.38a2.88 2.88 0 100-5.76 2.88 2.88 0 000 5.76z"
})));